import api from "./api";

export default class BaseApi {
  static async get() {
    return await api.get(`base`);
  }
}
